import type { NotificationType } from './Notification.types';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import {
  NotificationDescription,
  NotificationTitle,
} from './Notification.style';
import CheckIcon from 'shared/icons/CheckRounded';
import ErrorIcon from 'shared/icons/ErrorOutlined';
import InfoIcon from 'shared/icons/Info';
import WarningIcon from 'shared/icons/Warning';

function getIconByNotificationType(notificationType: NotificationType | null) {
  switch (notificationType) {
    case 'error':
      return ErrorIcon;
    case 'success':
      return CheckIcon;
    case 'warning':
      return WarningIcon;
    default:
      return InfoIcon;
  }
}

function getIconColorByNotificationType(
  notificationType: NotificationType | null
) {
  switch (notificationType) {
    case 'error':
      return '#A51010';
    case 'success':
      return '#218D7A';
    case 'warning':
      return 'rgb(219, 118, 0)';
    default:
      return 'rgb(34, 64, 96)';
  }
}

type NotificationProps = {
  description: string | null;
  title: string | null;
  type: NotificationType | null;
  onClose: () => void;
};

const Notification = ({
  description,
  title,
  type,
  onClose,
}: NotificationProps) => {
  const Icon = getIconByNotificationType(type);

  return (
    <Stack alignItems="center" spacing={3}>
      {title && <NotificationTitle>{title}</NotificationTitle>}
      <Icon
        sx={{ fontSize: '4rem', color: getIconColorByNotificationType(type) }}
      />
      <NotificationDescription>{description}</NotificationDescription>
      <Stack direction="row" justifyContent="flex-end" width="100%">
        <Button color="primary" variant="contained" onClick={onClose}>
          Ok
        </Button>
      </Stack>
    </Stack>
  );
};

export default Notification;
